import { render } from "./RegionSetting.vue?vue&type=template&id=0b72932f&scoped=true"
import script from "./RegionSetting.vue?vue&type=script&lang=js"
export * from "./RegionSetting.vue?vue&type=script&lang=js"

import "./RegionSetting.vue?vue&type=style&index=0&id=0b72932f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_13b2cfeee597e475bd48dd409a32edc8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b72932f"]])

export default __exports__